import { Link } from "react-router-dom";

export default function Footer() {
  return (
    <footer
      data-testid="site-footer"
      className="border-t border-subtle mt-24 md:mt-32"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12 lg:px-24 py-12 md:py-16">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-10">
          <div className="max-w-md">
            <div className="flex items-center gap-2">
              <span
                aria-hidden="true"
                className="w-6 h-6 rounded-md border border-strong flex items-center justify-center"
                style={{ background: "var(--surface)" }}
              >
                <span
                  className="block w-2 h-2 rounded-[2px]"
                  style={{ background: "var(--accent)" }}
                />
              </span>
              <span className="font-display text-primary font-medium tracking-tight">
                Scale Architect Labs
              </span>
            </div>
            <p className="mt-4 text-sm text-secondary leading-relaxed">
              A private dispatch on workspace architecture, visual automation,
              and the AI stack quietly running modern solo studios.
            </p>
          </div>

          <div className="flex flex-col sm:flex-row gap-8 sm:gap-16 font-mono text-[11px] uppercase tracking-[0.2em] text-tertiary">
            <div className="flex flex-col gap-3">
              <span className="text-tertiary">Library</span>
              <Link to="/notion" className="text-primary hover:text-[var(--accent)] transition-colors normal-case font-body tracking-normal text-sm">
                Notion Workspace
              </Link>
              <Link to="/automation" className="text-primary hover:text-[var(--accent)] transition-colors normal-case font-body tracking-normal text-sm">
                Visual Automation
              </Link>
              <Link to="/stack" className="text-primary hover:text-[var(--accent)] transition-colors normal-case font-body tracking-normal text-sm">
                AI Stack
              </Link>
            </div>

            <div className="flex flex-col gap-3">
              <span className="text-tertiary">Lab</span>
              <Link to="/" className="text-primary hover:text-[var(--accent)] transition-colors normal-case font-body tracking-normal text-sm">
                Join newsletter
              </Link>
              <span className="text-secondary normal-case font-body tracking-normal text-sm">
                hello@scalearchitect.co
              </span>
            </div>
          </div>
        </div>

        <div className="mt-12 pt-6 border-t border-subtle flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3 font-mono text-[10px] uppercase tracking-[0.22em] text-tertiary">
          <span>© {new Date().getFullYear()} Scale Architect Labs</span>
          <span>Built quietly · Shipped intentionally</span>
        </div>
      </div>
    </footer>
  );
}
